import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionExperiencePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.v1.questionExperience.heading')}
      buttons={[
        {
          text: t('pages.onboarding.v1.questionExperience.button1'),
          value: 'complete_beginner',
        },
        {
          text: t('pages.onboarding.v1.questionExperience.button2'),
          value: 'know_basics',
        },
        {
          text: t('pages.onboarding.v1.questionExperience.button3'),
          value: 'tried_a_lot',
        },
        {
          text: t('pages.onboarding.v1.questionExperience.button4'),
          value: 'skincare_enthusiast',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
